module.exports = __webpack_public_path__ + "fonts/CooperBlack.adc22c56.ttf";